<!-- eslint-disable -->
<template>
  <div class="menu-contain">
    <el-card class="left-contain">
        <h2 class="title">QUIZ</h2>
        <div>
            <div class="login-out-content">
                Hi，{{ use_name }}
                <span class="login-out" @click="loginOut()">注销</span>
            </div>
            <div>
                <el-menu :default-active="menu" @select="changeMenu">
                    <el-menu-item
                        index="quizList"
                    >
                        <i class="el-icon-tickets"></i>
                        <span slot="title">quiz列表</span>
                    </el-menu-item>
                    <el-menu-item
                        index="addQuiz"
                    >
                        <i class="el-icon-plus"></i>
                        <span slot="title">添加quiz</span>
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
    </el-card>
    <el-card class="right-contain">
        <!-- quiz列表 -->
        <quiz-list v-if="menu === 'quizList'" @toMenuList="changeMenu" @toEditQuiz="toEditQuiz"></quiz-list>
        <!-- 添加quiz -->
        <add-quiz v-else-if="menu === 'addQuiz'" @toMenuList="changeMenu" :editActicleId="edit_article_id"></add-quiz>
    </el-card>
  </div>
</template>
<!-- eslint-disable -->

<script>
import quizList from '../quiz-list/index.vue';
import addQuiz from '../add-quiz/index.vue';

export default {
    name: 'QuizMenu',
    components: {
        quizList,
        addQuiz
    },
    data() {
        return {
            menu: 'quizList',
            use_name: '管理员',
            edit_article_id: 0 // 点击编辑quiz的id
        };
    },
    mounted() {
        this.use_name = window.localStorage.getItem('User-Name');
    },
    methods: {
        changeMenu(index) {
            if (index === 'addQuiz') {
                this.edit_article_id = 0;
            }
            this.menu = index;
        },
        loginOut() {
            this.$confirm('您确认要退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.path.loginOut())
                    .then(res => {
                        window.localStorage.removeItem('User-Token');
                        window.localStorage.removeItem('User-Name');
                        this.$router.push('/');
                    });
            }).catch(() => {
            });
        },
        toEditQuiz(id) {
            this.edit_article_id = id;
            this.menu = 'addQuiz';
        }
    }
};
</script>

<style lang="less" scoped>
.menu-contain {
    height: calc(100vh - 40px);
    padding: 20px;
    overflow: hidden;
    .left-contain {
        position: relative;
        font-weight: bold;
        float: left;
        width: 18%;
        height: 100%;
        .title {
            // margin: 0;
            padding: 60px 20px 40px;
            font-size: 56px;
        }
        .login-out-content {
            line-height: 40px;
            margin-bottom: 30px;
            font-size: 16px;
            .login-out {
                font-size: 14px;
                color: #f56c6c;
                cursor: pointer;
            }
        }
        .el-menu {
            border: none;
            .el-menu-item {
                height: 42px;
                line-height: 42px;
                font-size: 15px;
                &.is-active {
                    background: #ecf5ff;
                }
            }
        }
    }
    .right-contain {
        margin-left: calc(18% + 16px);
        height: 100%;
        position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/quiz-menu/index.vue